import * as React from "react";
const SvgGeneric = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 79" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect
        width={125.43}
        height={78.39}
        fill="#F1F2F2"
        fillRule="nonzero"
        rx={4.18}
      />
      <path
        fill="#9B9B9B"
        fillRule="nonzero"
        d="M73.947 31.421v5.036s-3.351.017-3.368 0V31.42h-5.053s.017-3.352 0-3.368h5.053V23h3.368v5.053H79v3.368zm-5.052 6.737v-5.053h-5.053v-5.052H50.368A3.38 3.38 0 0 0 47 31.42v20.21A3.38 3.38 0 0 0 50.368 55h20.21a3.38 3.38 0 0 0 3.37-3.368V38.158zM50.368 51.632l5.053-6.737 3.368 5.052 5.053-6.736 6.737 8.42z"
      />
      <path d="M42 20h40v40H42z" />
    </g>
  </svg>
);
export default SvgGeneric;
